import { render, staticRenderFns } from "./StandardLayout.vue?vue&type=template&id=2a254de6&scoped=true"
import script from "./StandardLayout.vue?vue&type=script&lang=js"
export * from "./StandardLayout.vue?vue&type=script&lang=js"
import style0 from "./StandardLayout.vue?vue&type=style&index=0&id=2a254de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a254de6",
  null
  
)

export default component.exports